import React from "react";

import { Card } from "./card";
import { Props } from "./types";
import styles from "./styles.scss";

function Skeleton({ cardNumber }: Props) {
  return (
    <div className={styles.skeleton}>
      {[...Array(cardNumber)].map((_, key) => (
        <div key={key} className={styles.card}>
          <Card />
        </div>
      ))}
    </div>
  );
}

export { Skeleton };
